import firebase from "firebase/app";
import "firebase/firestore";
import { tVariantOption } from "tmt_api/src/types/types";
import { tProductState } from "./types";

export const kDefaultProduct: tProductState = {
  availability: "available",
  brandId: 0,
  brandUid: "",
  productId: "",
  brandName: "",
  case_minimum: 0,
  category: "Accessories - Electronics & Tech",
  categoryHierarchy: {
    lvl0: "Accessories",
    lvl1: "Accessories - Electronics & Tech",
  },
  description: "",
  height: "",
  images: [],
  inventory: 0,
  keywords: [],
  length: "",
  msrp_price: 0,
  name: "",
  processing_time: "",
  return_policy: "",
  shipping_terms: "",
  sku: "",
  upc: "",
  variantOptions: [],
  variants: [],
  weight: "",
  wholesale_price: 0,
  width: "",
  id: undefined,
  ingredients: "",
  materials: "",
  tester: undefined,
  useAndCare: "",
  uid: "",
  timeCreated: firebase.firestore.Timestamp.now(),
  timeUpdated: firebase.firestore.Timestamp.now(),
};
export const kDefaultVariantOption: tVariantOption = {
  labels: [""],
  name: "",
};
